import { render, staticRenderFns } from "./PerformanceIndicator.vue?vue&type=template&id=3abb1e56&"
import script from "./PerformanceIndicator.vue?vue&type=script&lang=js&"
export * from "./PerformanceIndicator.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceIndicator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports